import { render, staticRenderFns } from "./empresas.vue?vue&type=template&id=98076098&scoped=true&"
import script from "./empresas.vue?vue&type=script&lang=js&"
export * from "./empresas.vue?vue&type=script&lang=js&"
import style0 from "./empresas.vue?vue&type=style&index=0&id=98076098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98076098",
  null
  
)

export default component.exports